import { patchRequest } from '@/core';
import { maintenance } from '@/requests';

export default async function updateDeviationCauseRequest(id, patch) {
	let url = maintenance.getDeviationCausesByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}